/* eslint-disable no-console */
import 'rxjs';
import { Observable } from 'rxjs/Observable';
import { REJECT_INVITATION } from '../actions';

const epic = (action$, store, { api }) =>
    action$.ofType(REJECT_INVITATION).mergeMap(action => {
        console.log(`epic ${action}`);
        return (
            Observable.from(api.rejectInvitation(action.payload))
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                .map(response => toAction(response))
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                .catch(() => Observable.of(errorAction()))
        );
    });

const toAction = response =>
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    response ? console.log('Invitation rejected') : errorAction();

const errorAction = () => console.log('Invitation reject error');

export default epic;
